export const loaded: { [name: string]: boolean } = {};
export const loadPromises: { [name: string]: Promise<void> } = {};
